import React from "react";
import { ArrowRight, MessageSquare } from "lucide-react";
import { CALENDLY_URL } from "../../lib/site";

export default function FinalCTA({ onBookDemo, onTryAgent }) {
  return (
    <section data-testid="final-cta-section" className="bg-white text-[#0A0F1E] relative overflow-hidden border-y border-black/5">
      {/* subtle gold corner accents */}
      <div className="absolute -top-32 -right-32 h-72 w-72 rounded-full bg-[#C9A84C]/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 h-72 w-72 rounded-full bg-[#C9A84C]/5 blur-3xl" />

      <div className="fs-container fs-section relative">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#C9A84C]" />
            <span className="fs-tag">Ready to Stop the Leak?</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl uppercase tracking-[0.03em] leading-[0.95] text-[#0A0F1E]">
            The Customers You're Losing<br />
            Were <span className="text-[#C9A84C]">Already Sold.</span>
          </h2>
          <p className="mt-7 text-lg md:text-xl text-[#0F172A]/70 leading-relaxed max-w-2xl">
            They found your business. They visited your website. They were
            ready to move forward. They just couldn't get the answers they
            needed. Let's fix that — starting this week.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="final-primary-cta"
              onClick={onBookDemo}
              className="btn-primary"
            >
              Book Your Free Strategy Call <ArrowRight size={18} strokeWidth={2} />
            </button>
            <a
              data-testid="final-calendly-link"
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary-dark"
            >
              Open Calendly Directly
            </a>
            <button
              data-testid="final-secondary-cta"
              onClick={onTryAgent}
              className="text-[#0F172A]/70 hover:text-[#0A0F1E] text-sm underline-offset-4 hover:underline transition-colors inline-flex items-center gap-2"
            >
              <MessageSquare size={16} /> Try the Live Agent First
            </button>
          </div>

          <p className="mt-8 text-xs uppercase tracking-[0.2em] text-[#0F172A]/45">
            Free 30-minute call · No pressure · We'll tell you exactly what your business needs
          </p>
        </div>
      </div>
    </section>
  );
}
